module.exports = __webpack_public_path__ + "static/media/BronzeMedal.b9ec7e04.png";